import { ICellRendererParams } from 'ag-grid-enterprise';

export const TradingGridCellRenderer = (params: ICellRendererParams) => {
  const colId = params.colDef?.colId ?? '';
  const isBuyBtn = colId?.includes('buyBtn');
  const rowIndex = params.node.rowIndex;

  const isTradableCell = (params.data && !!params.data[colId.split('-')[0]].mid) || (rowIndex !== 0 && rowIndex !== 1);

  if (!isTradableCell) {
    return null;
  }

  return (
    <button
      style={{
        backgroundColor: isBuyBtn ? '#4189E8' : '#CD4B4B',
        border: 'none',
        textAlign: 'center',
        display: 'inline-block',
        borderRadius: 5,
        color: 'white',
        cursor: 'pointer',
        minHeight: 15,
        width: 35,
        fontSize: 11,
      }}
      data-testid={isBuyBtn ? `buy-button` : `sell-button`}
    >
      {isBuyBtn ? 'Buy' : 'Sell'}
    </button>
  );
};
